import * as React from 'react';

import { Button } from 'antd';

import { useQueryClient } from '@tanstack/react-query';
import productService from 'v2/services/product';

const FreightVinculation = () => {
  const queryClient = useQueryClient();

  const closeTab = React.useCallback(async () => {
    const params = new URL(document.location.href).searchParams;
    const melhorEnvioCode = params.get('code');
    await productService.enableMelhorEnvioAuth(melhorEnvioCode);
    queryClient.invalidateQueries({ queryKey: ['delivery-integrations'] });
    window.opener.handleCloseMelhorEnvioPopup();
    window.close();
  }, [queryClient]);

  return (
    <div className='flex min-h-[70vh] flex-col items-center justify-center px-4 text-center sm:px-6 [&_h1]:text-4xl [&_h1]:leading-6 [&_h1]:font-semibold [&_h1]:text-[#596375] [&_h2]:text-base [&_h2]:text-[#596375]'>
      <div className='notfound'>
        <h1>Vinculado com sucesso</h1>
        <br />
        <h2>Conta vinculada ao Melhor Envio</h2>
        <br />
      </div>
      <Button onClick={closeTab}>Ok</Button>
    </div>
  );
};

export default FreightVinculation;
